export default __webpack_public_path__ + "static/media/ic-info.24f8dc76.svg";